import {
  PlayerEvent,
  type AudioTrack,
  type AudioTrackSelectedEvent,
  type PlayerInterface,
} from '@foundation-player/loader';
import { readonly, writable, type Readable, type Writable } from 'svelte/store';
import type { PlayerStoreModule } from './player-store-types';

export class AudioTracksPlayerStore implements PlayerStoreModule<'availableAudioTracks' | 'activeAudioTrack'> {
  readonly #availableAudioTracks: Writable<AudioTrack[]> = writable([]);
  readonly availableAudioTracks: Readable<AudioTrack[]> = readonly(this.#availableAudioTracks);

  readonly #activeAudioTrack: Writable<AudioTrack | undefined> = writable(undefined);
  readonly activeAudioTrack: Readable<AudioTrack | undefined> = readonly(this.#activeAudioTrack);

  initializeStateFromPlayer(player: PlayerInterface) {
    player.addEventListener(PlayerEvent.ContentStart, () => {
      this.#syncStateFromPlayer(player);
    });

    player.addEventListener(PlayerEvent.AudioTrackSelected, (event: AudioTrackSelectedEvent) => {
      this.#activeAudioTrack.set(event.audioTrack);
    });

    player.addEventListener(PlayerEvent.Ready, () => {
      this.#syncStateFromPlayer(player);
    });

    this.#syncStateFromPlayer(player);
  }

  #syncStateFromPlayer(player: PlayerInterface) {
    this.#availableAudioTracks.set(player.getAvailableAudioTracks());
    this.#activeAudioTrack.set(player.getActiveAudioTrack());
  }
}
